
// export const environment = {
//   production: true,
//   apiUrl: 'http://127.0.0.1:1234'
// };

export const environment = {
  production: true,
  apiUrl: "https://happyagain.essex.ac.uk/api",
  recaptcha: {
    siteKey: '6LcRvXomAAAAAOYvYWh2A4NNZ9hBX3ra9wYA2LWj',
  },

  // apiUrl: 'https://debf-2800-150-11c-d8d-f8c0-381b-c348-2d85.ngrok.io'
};
